import {
  InternalAdvance,
  InternalAdvanceDetailGroup,
  InternalAdvanceDetailItem,
} from '@varo/graphql-schema-types';
import { isPositiveValue } from 'features/accounts/AccountDetails/AccountDetails.helpers';
import { TFunction } from 'i18next';
import { ListItemLineFormat } from 'shared/components/vxl/ListItem/ListItemTextStack';
import { SectionedContentScreenSection } from 'shared/containers/vxl/SectionedContentScreen/SectionedContentScreen';
import { VXLComponentId, VXLNode } from 'shared/renderer/types';

type AdvanceTranslatedText = TFunction<'advance', 'advanceDetails'>;

// For use of <SectionedContentScreen/> built in component this function helps to mke sections
const sectionListHelper = (
  detailData: InternalAdvance,
  translatedText: AdvanceTranslatedText,
) => {
  const sections: SectionedContentScreenSection[] = [];

  const advanceDetailGroup: InternalAdvanceDetailGroup[] =
    detailData?.detailsV2;

  if (detailData) {
    const sectionList: VXLNode[] = [];
    sectionList.push(
      {
        id: 'LIST_ITEM_ADVANCE_FEE',
        name: VXLComponentId.LIST_ITEM,
        props: {
          primaryCopy: translatedText('listItems.fee'),
          showsChevron: false,
          lineFormat: ListItemLineFormat.LABEL,
          trailingAccessory: {
            id: '1',
            name: VXLComponentId.LIST_ITEM_TEXT_STACK,
            props: {
              primaryCopy: detailData.fee?.formatted,
            },
          },
        },
      },
      {
        id: 'LIST_ITEM_ADVANCE_TOTAL',
        name: VXLComponentId.LIST_ITEM,
        props: {
          primaryCopy: translatedText('listItems.Total'),
          showsChevron: false,
          lineFormat: ListItemLineFormat.LABEL,
          trailingAccessory: {
            id: '3',
            name: VXLComponentId.LIST_ITEM_TEXT_STACK,
            props: {
              primaryCopy:
                '$' +
                (
                  Number(detailData.fee?.amount) +
                  Number(detailData.amount.amount)
                ).toFixed(2),
            },
          },
        },
      },
    );

    advanceDetailGroup
      ?.reduce((acc, curr) => {
        return [...acc, ...curr.items];
      }, [] as InternalAdvanceDetailItem[])
      .forEach((item) => {
        if (item.title === 'Auto-repayment date') {
          sectionList.push({
            id: item.id,
            name: VXLComponentId.LIST_ITEM,
            props: {
              primaryCopy: item.title,
              showsChevron: false,
              lineFormat: ListItemLineFormat.LABEL,
              trailingAccessory: {
                id: '3',
                name: VXLComponentId.LIST_ITEM_TEXT_STACK,
                props: {
                  primaryCopy: item.copy,
                },
              },
            },
          });
        }
      });
    sections.push({ data: sectionList });

    detailData.advancePayments?.forEach((section) => {
      const sectionData: VXLNode[] = [];
      section.children.forEach((payment) => {
        sectionData.push({
          id: payment.id,
          name: VXLComponentId.TRANSACTION_LIST_ITEM,
          props: {
            titleText: payment.primaryText.copy,
            secondaryText: payment.secondaryText?.copy,
            showsChevron: false,
            lineFormat: ListItemLineFormat.LABEL,
            amountText: payment.primaryDetail.copy,
            balanceText: payment.secondaryDetail?.copy,
            amountStyle: isPositiveValue(payment.primaryDetail.copy),
          },
        });
      });
      sections.push({
        sectionHeader: {
          id: section.id,
          name: VXLComponentId.SECTION_DIVIDER,
          props: {
            labelText: section.title.copy,
          },
        },
        data: sectionData,
      });
    });
  }

  return { sections };
};

export default sectionListHelper;
